import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { IUiSchema } from "@rentiohq/shared-frontend/dist/forms/forms.types";
import { ts } from "../../services";
import { EField } from "./schema.propertyInviteApplication.types";

export const getSchema = (_?: any) => (__: any) => ({
  required: [EField.Email],
  properties: {
    [EField.Email]: {
      format: "email",
      default: undefined,
    },
  },
});

export const uiSchema = (): IUiSchema<EField> => ({
  "rentio:navigationTitle": ts.propertyInviteApplicationModalHeading(),
  [EField.Email]: {
    "ui:field": ERentioFormField.Email,
    title: ts.propertyInviteApplicationEmailLabel(),
    autoFocus: true,
  },
});
